export type PlaceCategory = 'municipal' | 'sport' | 'culture' | 'parc' | 'ecocentre'

export interface Place {
  id: string
  name: string
  category: PlaceCategory
  address: string
  note: string
  open: boolean
  lat: number
  lng: number
}

export const placeCategories: Record<PlaceCategory, { label: string; color: string }> = {
  municipal: { label: 'Services municipaux', color: '#1d3f86' },
  sport: { label: 'Sports et loisirs', color: '#c8322b' },
  culture: { label: 'Culture et patrimoine', color: '#8a6212' },
  parc: { label: 'Parcs et haltes', color: '#276b43' },
  ecocentre: { label: 'Matières résiduelles', color: '#0e7490' },
}

export const cityCenter: [number, number] = [49.4186, -67.2986]

/**
 * Les lieux viennent du site de la Municipalité ; les coordonnées sont approximatives
 * et posées à la main, sauf le village et le phare. À recaler avant une présentation.
 */
export const places: Place[] = [
  {
    id: 'bureau-municipal',
    name: 'Bureau municipal',
    category: 'municipal',
    address: '28, route 138',
    note: 'Ouvre lundi',
    open: false,
    lat: 49.4186,
    lng: -67.2986,
  },
  {
    id: 'centre-de-tri',
    name: 'Centre de tri de Baie-Trinité',
    category: 'ecocentre',
    address: 'Baie-Trinité',
    note: 'Fermé le samedi 19 septembre',
    open: false,
    lat: 49.4205,
    lng: -67.3048,
  },
  {
    id: 'bibliotheque',
    name: 'Bibliothèque municipale',
    category: 'culture',
    address: 'Baie-Trinité',
    note: 'Consulter l’horaire',
    open: true,
    lat: 49.419,
    lng: -67.2978,
  },
  {
    id: 'caserne',
    name: 'Service incendie',
    category: 'municipal',
    address: 'Baie-Trinité',
    note: 'Urgences : 911',
    open: true,
    lat: 49.418,
    lng: -67.3005,
  },
  {
    id: 'voirie',
    name: 'Garage municipal — Service de la voirie',
    category: 'municipal',
    address: 'Baie-Trinité',
    note: 'Déneigement et entretien des chemins',
    open: true,
    lat: 49.4172,
    lng: -67.302,
  },
  {
    id: 'phare-pointe-des-monts',
    name: 'Phare de Pointe-des-Monts',
    category: 'culture',
    address: 'Chemin du Vieux-Phare',
    note: 'Site historique · saison estivale',
    open: false,
    lat: 49.3225,
    lng: -67.3775,
  },
  {
    id: 'centre-de-tri-godbout',
    name: 'Centre de tri de Godbout',
    category: 'ecocentre',
    address: 'Godbout',
    note: 'Ouvre le dimanche qui suit celui de Baie-Trinité',
    open: false,
    lat: 49.3231,
    lng: -67.6069,
  },
]
